import { DeleteCroquisSketchQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteCroquisSketch/deleteCroquisSketchQuery.type';
import { deleteCroquisSketchFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteCroquisSketch/deleteCroquisSketchQueryFunction';

export const deleteCroquisSketchQueryOptions = () => {
  return {
    mutationKey: ['deleteCroquisSketch'],
    mutationFn: (params: DeleteCroquisSketchQueryParamsType) =>
      deleteCroquisSketchFunction(params),
  };
};
